import Vue from 'vue';
import axios from 'axios'
import { Toast } from 'vant'
import { v4 as uuidv4 } from 'uuid'
import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'
// 国际化参数 START
import '@hotelcem/apis/interceptors/request/LangInterceptors'
// 国际化参数 END
// DEMO START
import '@hotelcem/apis/interceptors/response/DemoInterceptors'

    import store from '@/xreports/store'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
// DEMO END

class MOpenBaseAPI {
  constructor(config) {
    this.config = {
      baseURL: `${process.env.VUE_APP_APIBASEURL}`,
      timeout: 5000000,
      withCredentials: true,
      ...config,
    }
  }

  /**
   * Request API method
   * @param {String} method
   * @param {String} url
   * @param {Object} rBody
   */

  async fetch(method, params, headers = {}) {
    const reqId = uuidv4().replace(/-/g, '')

    let hed = {
      ...headers,
      reqId: reqId,
      Authorization: getAppBaseConfig().appId,
    }
    let token = getAppBaseConfig().token || store.state.systemUser.token
    if (token) {
      hed.token = token
    }

    if (getAppBaseConfig().loginSsoToken) {
      hed.ssoToken = getAppBaseConfig().loginSsoToken || ''
    }

    return axios({
      headers: hed,
      ...this.config,
      method,
      ...params,
    })
      .then(res => {
        if (!res || !res.data) {
          return Promise.reject(res || 'Empty HttpResponse')
        }
        const { data, code, msg, msgcode } = res.data
        if (msgcode && ['GENERAL_ERROR_ALERT'].includes(msgcode)) {
          Toast(msg)
        }
        if (code === '707001' || code === 'SUCCESS') {
          return Promise.resolve(res.data)
        }

        // 当前账号无权限
        if (code === 403) {
          return Promise.reject({ type: 'cancel' })
        }
        if (code !== 200) {
          if (msgcode === 'CEM_1_0001') {
            return Promise.resolve({})
          } else if (msgcode && ['WARN_RECORD_DELETED', 'FEEDBACK'].includes(msgcode)) {
            return Promise.resolve({ msgcode, msg })
          }
          // else if (msgcode === 'VOICE_DELETED') {
          //   return Promise.reject({
          //     response: {
          //       data: {
          //         msg,
          //       },
          //     },
          //   })
          // }
          else {
            return Promise.reject(msg)
          }
        }
        return Promise.resolve(data)
      })
      .catch(error => {
        console.error(`response error: url=${params.url}; reqId = ${reqId}; `)

        if (error?.type === 'cancel' || (error?.isAxiosError && error?.response?.status === 401)) {
          store.dispatch('systemUser/logout')
          return Promise.reject(error)
        } else {
          const { msgcode = '', msg = '' } = error?.response?.data || {}
          if (['GENERAL_ERROR_ALERT'].includes(msgcode)) {
            Toast(msg)
          }

          Toast(error?.response?.data?.msg || error || $t('e651e1'))
          return Promise.reject(error)
        }
      })
  }

  async get(params, headers) {
    return this.fetch(
      'GET',
      {
        ...params,
        timestamp: Date.now(),
      },
      headers
    )
  }

  async post(body, headers) {
    return this.fetch('POST', body, headers)
  }
}

export default MOpenBaseAPI
